import { IGroup } from '../types/IGroup';
import { IGroupMember } from '../types/IGroupMember';
import { Request } from './Request';

export interface IGetUsersGroupMembershipParams {
  userIds: string[];
  siteId?: string;
}

export interface IGetUsersGroupMembershipResult {
  members: IGroupMember[];
  groups: IGroup[];
}

export class GetUsersGroupMembershipRequest extends Request<IGetUsersGroupMembershipParams, IGetUsersGroupMembershipResult> {
  constructor(params: IGetUsersGroupMembershipParams) {
    super('getUsersGroupMembership', params);
  }
}
